import {courierDetail as _COURIERS_} from "@/config/courierCodes";
import Vue from "vue";
const vm = new Vue();
// import moment from "moment";
let rules = {
  JNT: {
    maxSize: {
      width: 100,
      length: 100,
      height: 100,
    },
    maxWeight: 50000,
    maxWLH: 180,
    dimensionRatio: 6000,
    // allowOverDimensionWeight: true,
    zoneName: {
      1: 'ต้นทาง: กรุงเทพและปริมณฑล ปลายทาง: กรุงเทพและปริมณฑล',
      2: 'ต้นทาง: กรุงเทพและปริมณฑล ปลายทาง: ต่างจังหวัด',
      3: 'ต้นทาง: ต่างจังหวัด ปลายทาง: กรุงเทพมหานคร',
      4: 'ต้นทาง: ต่างจังหวัด ปลายทาง: ต่างจังหวัด'
    },
  },
  BEST: {
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 600,
    dimensionRatio: 6000,
    zoneName: {
      1: "ส่งภายใน: กรุงเทพฯ/ปริมณฑล",
      2: "ต้นทาง:  กรุงเทพฯ/ปริมณฑล - ปลายทาง: ต่างจังหวัด",
      3: "ต้นทาง: ต่างจังหวัด - ปลายทาง: กรุงเทพฯ/ปริมณฑล",
      4: "ต้นทาง: ต่างจังหวัด - ปลายทาง: ต่างจังหวัด",
    },
  },
  TRUE: {
    maxSize: {
      width: 150,
      length: 150,
      height: 150,
    },
    maxWLH: 200,
    banner: {
      code: `DF_TRUE${vm.$THEME.bannerPrefix}`,
    },
    alertText: {
      text: "สามารถสร้างรายการพัสดุและชำระค่าบริการจัดส่งพัสดุก่อน 18.00 น. ",
      emphasize: "ขนส่งจะเข้ารับพัสดุในวันถัดไป (ไม่มีเข้ารับภายในวัน )",
    },
    zoneName: {
      1: "ปลายทาง: กรุงเทพฯ/ปริมณฑล",
      2: "ปลายทาง: ต่างจังหวัด",
    },
  },
  ECP: {
    maxSize: {
      width: 60,
      length: 60,
      height: 70,
    },
    zoneName: {
      null: "ทั่วไป",
    },
  },
  FLE: {
    maxSize: {
      width: 150,
      length: 150,
      height: 150,
    },
    maxWLH: 280,
    banner: {
      code: `DF_FLE${vm.$THEME.bannerPrefix}`,
    },
    alertText: {
      text: [
        "เนื่องจาก Flash Express มีการปรับปรุงระบบเข้ารับพัสดุ",
        "กรุณาแยกกองพัสดุเพื่อให้ขนส่งเข้ารับโดยรายการที่สร้างภายในวันที่ 18 พ.ย. 64 ก่อนเวลา 23.59น. ไว้กองหนึ่งและรายการที่สร้างหลังจากวันและเวลาดังกล่าวไว้อีกกองหนึ่ง",
      ],
    },
    zoneName: {
      1: "ต้นทางและปลายทาง: กรุงเทพฯ/ปริมณฑล",
      2: "ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      3: "ต้นทาง: เหนือ, อีสาน, ใต้, กลาง - ปลายทาง: กรุงเทพฯ/ปริมณฑล",
      4: "ต้นทาง: เหนือ - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      5: "ต้นทาง: อีสาน - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      6: "ต้นทาง: ใต้ - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      7: "ต้นทาง: กลาง - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      8: "ต้นทาง - ปลายทาง: ภายในจังหวัด (เหนือ)",
      9: "ต้นทาง - ปลายทาง: ภายในจังหวัด (อีสาน)",
      10: "ต้นทาง - ปลายทาง: ภายในจังหวัด (ใต้)",
      11: "ต้นทาง - ปลายทาง: ภายในจังหวัด (กลาง)",
    },
  },
  FLEF: {
    maxSize: {
      width: 150,
      length: 150,
      height: 150,
    },
    maxWLH: 280,
    banner: {
      code: `DF_FLE${vm.$THEME.bannerPrefix}`,
    },
    // alertText: {
    //   text: [
    //     "เนื่องจาก Flash Express มีการปรับปรุงระบบเข้ารับพัสดุ",
    //     "กรุณาแยกกองพัสดุเพื่อให้ขนส่งเข้ารับโดยรายการที่สร้างภายในวันที่ 18 พ.ย. 64 ก่อนเวลา 23.59น. ไว้กองหนึ่งและรายการที่สร้างหลังจากวันและเวลาดังกล่าวไว้อีกกองหนึ่ง",
    //   ],
    // },
    zoneName: {
      1: "ต้นทางและปลายทาง: กรุงเทพฯ/ปริมณฑล",
      2: "ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      3: "ต้นทาง: เหนือ, อีสาน, ใต้, กลาง - ปลายทาง: กรุงเทพฯ/ปริมณฑล",
      4: "ต้นทาง: เหนือ - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      5: "ต้นทาง: อีสาน - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      6: "ต้นทาง: ใต้ - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      7: "ต้นทาง: กลาง - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      8: "ต้นทาง - ปลายทาง: ภายในจังหวัด (เหนือ)",
      9: "ต้นทาง - ปลายทาง: ภายในจังหวัด (อีสาน)",
      10: "ต้นทาง - ปลายทาง: ภายในจังหวัด (ใต้)",
      11: "ต้นทาง - ปลายทาง: ภายในจังหวัด (กลาง)",
    },
  },
  FLEB: {
    maxSize: {
      width: 160,
      length: 160,
      height: 160,
    },
    maxWLH: 400,
    minWeight: 5001,
    dimensionRatio: 6000,
    allowOverDimensionWeight: true,
    dimensionWeightPrice: 20, // per kg
    zoneName: {
      1: "ต้นทางและปลายทาง: กรุงเทพฯ/ปริมณฑล",
      2: "ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: ต่างจังหวัด",
      3: "ต้นทางและปลายทาง: ต่างจังหวัด (ภายในจังหวัดเดียวกัน)",
      4: "ต้นทางและปลายทาง: ต่างจังหวัด",
      5: "ต้นทาง: ต่างจังหวัด - ปลายทาง: กรุงเทพฯ/ปริมณฑล",
    },
  },
  FLEWP: {
    maxSize: {
      width: 150,
      length: 150,
      height: 150,
    },
    maxWLH: 40,
    maxWeight: 1000,
    zoneName: {
      1: "ต้นทางและปลายทาง: เป็นจังหวัดเดียวกัน (ยกเว้นภาคกลาง, กรุงเทพฯ/ปริมณฑล)",
      2: "ต้นทาง: เหนือ, อีสาน,ใต้ ปลายทาง กทม/ปริมณฑล (ยกเว้นภาคกลาง)",
      3: "ต้นทาง: ภาคเหนือ - ปลายทาง: ทั่วประเทศ (ยกเว้นกรุงเทพฯ/ปริมณฑล)",
      4: "ต้นทาง: ภาคอีสาน - ปลายทาง: ทั่วประเทศ (ยกเว้นกรุงเทพฯ/ปริมณฑล)",
      5: "ต้นทาง: ภาคใต้ - ปลายทาง: ทั่วประเทศ (ยกเว้นกรุงเทพฯ/ปริมณฑล)",
      6: "ต้นทางและปลายทางภายในจังหวัด กรุงเทพฯ/ปริมณฑล",
      7: "ต้นทาง: ภาคกลาง, กรุงเทพฯ/ปริมณฑล- ปลายทาง: ทั่วประเทศ",
      8: "ต้นทางและปลายทาง: ภายในจังหวัดเดียวกันภาคกลาง (ยกเว้น กรุงเทพฯ/ปริมณฑล)",
      9: "ต้นทาง: ภาคกลาง(ยกเว้นกรุงเทพฯ/ปริมณฑล) - ปลายทาง: กรุงเทพฯ/ปริมณฑล",
    },
  },
  FLEDS: {
    maxSize: {
      width: 220,
      length: 220,
      height: 220,
    },
    maxWLH: 660,
    maxWeight: 100000,
    banner: {
      code: `DF_FLEDS${vm.$THEME.bannerPrefix}`,
    },
    zoneName: {
      null: "ทั่วไป",
    },
    alertText: {
      text: {
        0: "กรุณาส่งมอบพัสดุให้ทางขนส่ง<span style='color: red;'>ภายในเวลา 21.00 น.</span>",
        1: "หากส่งมอบล่าช้าจะทำให้เกิดค่าปรับ และเมื่อยิงเข้าระบบแล้ว<span style='color: red;'>ไม่สามารถยกเลิกได้ทุกกรณี</span>",
        2: "! ข้อเสนอแนะหากขนส่งเข้ารับพัสดุแล้วรบกวนยิงรับงานเข้าระบบในวันถัดไป"
      },
      emphasize: "",
    },
  },
  BEE: {
    maxSize: {
      width: 100,
      height: 100,
      length: 100,
    },
    maxWLH: 150,
    dimensionRatio: 6000,
    banner: {
      code: `DF_BEE${vm.$THEME.bannerPrefix}`,
    },
    alertText: {
      text:
        "ขนส่งจะเข้ารับเฉพาะต้นทางในจังหวัดกรุงเทพมหานครเท่านั้น กรณีจะทำการส่งพัสดุ ขนาดกล่อง (กว้าง+ยาว+สูง) รวมกันทุกด้านเกิน 130 เซนติเมตร หรือด้านใดด้านหนึ่งเกินกว่า 50 เซนติเมตร หรือน้ำหนักเกินกว่า 7 กิโลกรัม จะต้องทำ",
      emphasize: "รายการล่วงหน้าอย่างน้อย 1 วัน",
    },
    zoneName: {
      1: "กรุงเทพฯ",
    },
  },
  TPSD: {
    maxSize: {
      width: 100,
      height: 100,
      length: 100,
    },
    maxWLH: 150,
    dimensionRatio: 6000,
    banner: {
        code: `DF_TPSD${vm.$THEME.bannerPrefix}`,
    },
    zoneName: {
      1: "ทั่วไป",
    },
  },
  EMST: {
    maxSize: {
      width: 60,
      length: 60,
      height: 60,
    },
    maxWLH: 120,
    zoneName: {
      null: "ทั่วไป",
    },
    // ...(vm.$THEME.name == "quickexpress" ? {maxWeight: 1000} : {}),
  },
  EMSX: {
    maxSize: {
      width: 60,
      length: 60,
      height: 60,
    },
    maxWLH: 120,
    zoneName: {
      null: "ทั่วไป",
    },
    maxWeight: 1000,
  },
  EMSW: {
    maxSize: {
      width: 120,
      length: 120,
      height: 120,
    },
    maxWLH: 190,
    zoneName: {
      null: "ทั่วไป",
    },
    minWeight: 1001,
  },
  TP2: {
    maxSize: {
      width: 120,
      length: 120,
      height: 120,
    },
    maxWLH: 120,
    zoneName: {
      null: "ทั่วไป",
    },
  },
  THP: {
    maxSize: {
      width: 120,
      length: 120,
      height: 120,
    },
    maxWLH: 190,
    zoneName: {
      null: "ทั่วไป",
    },
  },
  MSE: {
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 200,
    banner: {
      code: `DF_MSE${vm.$THEME.bannerPrefix}`,
    },
    alertText: {
      text:
        "ขนส่งให้บริการ ทุกวันจันทร์ - วันเสาร์ (หยุดวันอาทิตย์ และวันหยุดนักขัตฤกษ์)",
      emphasize: "ขนส่งนี้ ต้องมียอดการจัดส่งพัสดุขั้นต่ำ 3 ชิ้นขึ้นไป",
    },
    zoneName: {
      1: "ต้นทาง: กรุงเทพฯ - ปริมณฑล ปลายทาง: กรุงเทพฯ",
      2: "ต้นทาง: กรุงเทพฯ - ปริมณฑล ปลายทาง: ปริมณฑล",
    },
  },
  MSEC: {
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 200,
    banner: {
      code: `DF_MSEC${vm.$THEME.bannerPrefix}`,
    },
    alertText: {
      text:
        "ขนส่งให้บริการ ทุกวันจันทร์ - วันเสาร์ (หยุดวันอาทิตย์ และวันหยุดนักขัตฤกษ์)",
      emphasize: "ขนส่งนี้ ต้องมียอดการจัดส่งพัสดุขั้นต่ำ 3 ชิ้นขึ้นไป",
    },
    zoneName: {
      1: "ต้นทาง: กรุงเทพฯ - ปริมณฑล ปลายทาง: กรุงเทพฯ",
      2: "ต้นทาง: กรุงเทพฯ - ปริมณฑล ปลายทาง: ปริมณฑล",
    },
  },
  MSEF: {
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 200,
    banner: {
      code: `DF_MSEF${vm.$THEME.bannerPrefix}`,
    },
    alertText: {
      text:
        "ขนส่งให้บริการ ทุกวันจันทร์ - วันเสาร์ (หยุดวันอาทิตย์ และวันหยุดนักขัตฤกษ์)",
      emphasize: "ขนส่งนี้ ต้องมียอดการจัดส่งพัสดุขั้นต่ำ 3 ชิ้นขึ้นไป",
    },
    zoneName: {
      1: "ต้นทาง: กรุงเทพฯ - ปริมณฑล ปลายทาง: กรุงเทพฯ",
      2: "ต้นทาง: กรุงเทพฯ - ปริมณฑล ปลายทาง: ปริมณฑล",
    },
  },
  SPE: {
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 200,
    banner: {
      code: `DF_SPE${vm.$THEME.bannerPrefix}`,
    },
    alertText: {
      text: "ขนส่งนี้ ต้องมียอดการจัดส่งพัสดุขั้นต่ำ 3 ชิ้นขึ้นไป",
      emphasize: "",
    },
    zoneName: {
      1: "ต้นทาง: กรุงเทพฯ - ปริมณฑล ปลายทาง: กรุงเทพฯ",
      2: "ต้นทาง:	กรุงเทพฯ - ปริมณฑล ปลายทาง: ปริมณฑล (นนทบุรี, ปทุมธานี, สมุทรปราการ นครปฐม และสมุทรสาคร)",
      3: "ต้นทาง:	กรุงเทพฯ - ปริมณฑล ปลายทาง:	ต่างจังหวัด (ชลบุรี, ราชบุรี, เพชรบุรี, หัวหิน, สมุทรสงคราม, นครราชสีมา)",
      4: "ต้นทาง:	ชลบุรี ปลายทาง:	ภายในจังหวัด",
      5: "ต้นทาง:	ชลบุรี ปลายทาง:	กรุงเทพฯ-ปริมณฑล",
      6: "ต้นทาง: เพชรบุรี, หัวหิน, สมุทรสงคราม, ราชบุรี ปลายทาง:	ภายในจังหวัด",
      7: "ต้นทาง: เพชรบุรี, หัวหิน, สมุทรสงคราม, ราชบุรี ปลายทาง:	จังหวัดใกล้เคียง",
      8: "ต้นทาง:	เพชรบุรี, หัวหิน, สมุทรสงคราม, ราชบุรี ปลายทาง:	กรุงเทพฯ-ปริมณฑล",
      9: "ต้นทาง:	ขอนแก่น, นครศรีธรรมราช ปลายทาง:	ภายในจังหวัด",
      10: "ต้นทาง: นครราชสีมา ปลายทาง: ภายในจังหวัด",
      11: "ต้นทาง: นครราชสีมา ปลายทาง: กรุงเทพฯ - ปริมณฑล",
    },
  },
  SPEC: {
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 200,
    banner: {
      code: `DF_SPEC${vm.$THEME.bannerPrefix}`,
    },
    alertText: {
      text: "ขนส่งนี้ ต้องมียอดการจัดส่งพัสดุขั้นต่ำ 3 ชิ้นขึ้นไป",
      emphasize: "",
    },
    zoneName: {
      1: "ต้นทาง: กรุงเทพฯ - ปริมณฑล ปลายทาง: กรุงเทพฯ",
      2: "ต้นทาง:	กรุงเทพฯ - ปริมณฑล ปลายทาง: ปริมณฑล (นนทบุรี, ปทุมธานี, สมุทรปราการ นครปฐม และสมุทรสาคร)",
      3: "ต้นทาง:	กรุงเทพฯ - ปริมณฑล ปลายทาง:	ต่างจังหวัด (ชลบุรี, ราชบุรี, เพชรบุรี, หัวหิน, สมุทรสงคราม, นครราชสีมา)",
      4: "ต้นทาง:	ชลบุรี ปลายทาง:	ภายในจังหวัด",
      5: "ต้นทาง:	ชลบุรี ปลายทาง:	กรุงเทพฯ-ปริมณฑล",
      6: "ต้นทาง: เพชรบุรี, หัวหิน, สมุทรสงคราม, ราชบุรี ปลายทาง:	ภายในจังหวัด",
      7: "ต้นทาง: เพชรบุรี, หัวหิน, สมุทรสงคราม, ราชบุรี ปลายทาง:	จังหวัดใกล้เคียง",
      8: "ต้นทาง:	เพชรบุรี, หัวหิน, สมุทรสงคราม, ราชบุรี ปลายทาง:	กรุงเทพฯ-ปริมณฑล",
      9: "ต้นทาง:	ขอนแก่น, นครศรีธรรมราช ปลายทาง:	ภายในจังหวัด",
      10: "ต้นทาง: นครราชสีมา ปลายทาง: ภายในจังหวัด",
      11: "ต้นทาง: นครราชสีมา ปลายทาง: กรุงเทพฯ - ปริมณฑล",
    },
  },
  CJLX: {
    maxSize: {
      width: 100,
      length: 100,
      height: 100,
    },
    maxWLH: 180,
    zoneName: {
      1: "กรุงเทพฯ/ปริมณฑล",
      2: "ต่างจังหวัด",
    },
  },
  EMSXP: {
    maxSize: {
      width: 60,
      length: 60,
      height: 60,
    },
    maxWLH: 120,
    zoneName: {
      1: "ปลายทาง: กรุงเทพฯ/ปริมณฑล",
      2: "ปลายทาง: ต่างจังหวัด",
    },
  },
  KRYQ: {
    allowOverDimensionWeight: true,
    allowOverWeight: true,
    dimensionWeightPrice: 13.5,
    maxWeight: 30000,
    maxDimensionWeight: 200000,
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 280,
    zoneName: {
      1: "ต้นทางและปลายทาง: กรุงเทพฯ/ปริมณฑล",
      2: "ต้นทาง: กรุงเทพฯ/ปริมณฑล ปลายทาง: ทุกภาค",
      3: "ต้นทาง: ภาคกลาง/ตะวันออก ปลายทาง: กรุงเทพฯ/ปริมณฑล",
      4: "ต้นทาง: ภาคกลาง/ตะวันออก ปลายทาง: ทุกภาค",
      5: "ต้นทาง: ภาคกลาง/ตะวันออก ปลายทาง: ภายในจังหวัดเดียวกัน",
      6: "ต้นทาง: ภาคเหนือ/ตะวันออกเฉียงเหนือ/ใต้ ปลายทาง: กรุงเทพฯ/ปริมณฑล",
      7: "ต้นทาง: ภาคเหนือ ปลายทาง: ทุกภาค",
      8: "ต้นทาง: ภาคตะวันออกเฉียงเหนือ ปลายทาง: ทุกภาค",
      9: "ต้นทาง: ภาคใต้ ปลายทาง: ทุกภาค",
      10: "ต้นทาง: ภาคเหนือ ปลายทาง: ภายในจังหวัดเดียวกัน",
      11: "ต้นทาง: ภาคตะวันออกเฉียงเหนือ ปลายทาง: ภายในจังหวัดเดียวกัน",
      12: "ต้นทาง: ภาคใต้ ปลายทาง: ภายในจังหวัดเดียวกัน",
      null: "ทั่วไป",
    },
  },
  ORNG: {
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 280,
    zoneName: {
      1: "ต้นทางและปลายทาง: กรุงเทพฯ/ปริมณฑล",
      2: "ต้นทาง: กรุงเทพฯ/ปริมณฑล ปลายทาง: ทุกภาค",
      3: "ต้นทาง: ภาคกลาง/ตะวันออก/ตะวันตก ปลายทาง: กรุงเทพฯ/ปริมณฑล",
      4: "ต้นทาง: ภาคกลาง/ตะวันออก/ตะวันตก ปลายทาง: ทุกภาค",
      5: "ต้นทาง: ภาคกลาง/ตะวันออก/ตะวันตก ปลายทาง: ภายในจังหวัดเดียวกัน",
      6: "ต้นทาง: ภาคเหนือ/ตะวันออกเฉียงเหนือ/ใต้ ปลายทาง: กรุงเทพฯ/ปริมณฑล",
      7: "ต้นทาง: ภาคเหนือ ปลายทาง: ทุกภาค",
      8: "ต้นทาง: ภาคตะวันออกเฉียงเหนือ ปลายทาง: ทุกภาค",
      9: "ต้นทาง: ภาคใต้ ปลายทาง: ทุกภาค",
      10: "ต้นทาง: ภาคเหนือ ปลายทาง: ภายในจังหวัดเดียวกัน",
      11: "ต้นทาง: ภาคตะวันออกเฉียงเหนือ ปลายทาง: ภายในจังหวัดเดียวกัน",
      12: "ต้นทาง: ภาคใต้ ปลายทาง: ภายในจังหวัดเดียวกัน",
      null: "ทั่วไป",
    },
    // dimensionRatio: 5000,
    lockPrice: false,
  },
  NJV: {
    maxSize: {
      width: 100,
      length: 100,
      height: 100,
    },
    maxWLH: 180,
    maxWeight: 35000,
    zoneName: {
      1: "กรุงเทพฯ/ปริมณฑล",
      2: "ต่างจังหวัด",
    },
  },
  SCG: {
    banner: {
      code: `DF_SCG${vm.$THEME.bannerPrefix}`,
    },
    alertText: {
      text: {
        0: "การดำเนินการจัดส่งพัสดุ",
        1: "(ทั้งพัสดุธรรมดาและพัสดุแช่เย็น-แช่แข็ง)",
        2: "1.กรุงเทพฯและปริมณฑล ระยะเวลาการจัดส่ง 1-2 วัน จัดส่งโดย SCG Express",
        3: "2.ต่างจังหวัด ระยะเวลาการจัดส่ง 2-4 วัน จัดส่งโดย 3 Party Logistics",
      },
      emphasize: "",
    },
    zoneName: {
      1: "ต้นทางและปลายทางอยู่ภาคเดียวกัน",
      2: "ต้นทางและปลายทางอยู่คนละภาค",
    },
  },
  SCGC: {
    banner: {
      code: `DF_SCGC${vm.$THEME.bannerPrefix}`,
    },
    alertText: {
      text:
        "ขยายพื้นที่จัดส่งพัสดุแช่เย็น-แช่แข็ง: ส่งได้ทุกอำเภอ ทั่วประเทศ 1.ปลายทางกรุงเทพฯ และปริมณฑล รับพัสดุได้ทุกขนาด 2.ปลายทางต่างจังหวัด รับพัสดุได้ไม่เกิน S100",
      emphasize: "",
    },
    zoneName: {
      1: "ภายในจังหวัดเดียวกัน",
      2: "ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: ต่างจังหวัด",
      3: "ต้นทาง: ต่างจังหวัด - ปลายทาง: ต่างจังหวัด",
    },
  },
  SCGF: {
    banner: {
      code: `DF_SCGF${vm.$THEME.bannerPrefix}`,
    },
    alertText: {
      text:
        "ขยายพื้นที่จัดส่งพัสดุแช่เย็น-แช่แข็ง: ส่งได้ทุกอำเภอ ทั่วประเทศ 1.ปลายทางกรุงเทพฯ และปริมณฑล รับพัสดุได้ทุกขนาด 2.ปลายทางต่างจังหวัด รับพัสดุได้ไม่เกิน S100",
      emphasize: "",
    },
    zoneName: {
      1: "ภายในจังหวัดเดียวกัน",
      2: "ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: ต่างจังหวัด",
      3: "ต้นทาง: ต่างจังหวัด - ปลายทาง: ต่างจังหวัด",
    },
  },
  KRYDS: {
    maxSize: {
      width: 100,
      length: 100,
      height: 100,
    },
    maxWLH: 180,
    maxWeight: 50000,
    zoneName: {
      null: "ทั่วไป",
    },
  },
  KRYS: {
    zoneName: {
      1: "ต้นทาง: กรุงเทพ/ปริมณฑล ปลายทาง: ภายในภาคเดียวกัน",
      2: "ต้นทาง: กรุงเทพ/ปริมณฑล ปลายทาง: ข้ามภาค",
      3: "ต้นทาง: 23 จังหวัด ปลายทาง: ภายในจังหวัดเดียวกัน",
      4: "ต้นทาง: 23 จังหวัด ปลายทาง: ภายในภาคเดียวกัน",
      5: "ต้นทาง: 23 จังหวัด ปลายทาง: ข้ามภาค",
      6: "ต้นทาง: 50 จังหวัด ปลายทาง: ภายในจังหวัดเดียวกัน",
      7: "ต้นทาง: 50 จังหวัด ปลายทาง: ภายในภาคเดียวกัน",
      8: "ต้นทาง: 50 จังหวัด ปลายทาง: ข้ามภาค",
    },
    allowOverDimensionWeight: true,
    allowOverWeight: true,
    dimensionWeightPrice: 13.5,
    maxWeight: 30000,
    maxDimensionWeight: 200000,
  },
  SPXP: {
    zoneName: {
      1: "ต้นทาง - ปลายทาง: กรุงเทพฯ/ปริมณฑล",
      2: "ต้นทาง:  กรุงเทพฯ/ปริมณฑล - ปลายทาง: ต่างจังหวัด",
      3: "ต้นทาง: ต่างจังหวัด - ปลายทาง: กรุงเทพฯ/ปริมณฑล",
      4: "ต้นทาง - ปลายทาง: ต่างจังหวัด",
    },
    maxSize: {
      width: 100,
      length: 100,
      height: 100,
    },
    maxWLH: 180,
    maxWeight: 20000,
    dimensionRatio: 5000,
    allowOverDimensionWeight: true,
    dimensionWeightPrice: 25, // per kg
    useDimensionWeightOnly: false,
  },
    XPSO: {
        maxSize: {
            width: 60,
            length: 60,
            height: 60,
        },
        maxWLH: 80,
        useZoneIndex: true, // โซนเดียวแต่อยากใช้ type 1
        zoneName: {
            1: "ต้นทางและปลายทาง: กรุงเทพฯ/ปริมณฑล",
        },
        banner: {
            code: `DF_XPSO${vm.$THEME.bannerPrefix}`,
        },
        alertText: {
            text:"ขนส่งให้บริการ ทุกวันจันทร์ - วันเสาร์ (หยุดวันอาทิตย์ และวันหยุดนักขัตฤกษ์)",
            emphasize: "ขนส่งนี้ ต้องมียอดการจัดส่งพัสดุขั้นต่ำ 3 ชิ้นขึ้นไป (กรณีพัสดุต่ำกว่า 3 ชิ้น คิดค่าบริการเข้ารับ 100 บาท)",
        },
    },
    XPSD: {
        maxSize: {
            width: 60,
            length: 60,
            height: 60,
        },
        maxWLH: 80,
        useZoneIndex: true, // โซนเดียวแต่อยากใช้ type 1
        zoneName: {
            1: "ต้นทางและปลายทาง: กรุงเทพฯ/ปริมณฑล",
        },
        banner: {
            code: `DF_XPSD${vm.$THEME.bannerPrefix}`,
        },
        alertText: {
            text:"ขนส่งให้บริการ ทุกวันจันทร์ - วันเสาร์ (หยุดวันอาทิตย์ และวันหยุดนักขัตฤกษ์)",
            emphasize: "ขนส่งนี้ ต้องมียอดการจัดส่งพัสดุขั้นต่ำ 3 ชิ้นขึ้นไป (กรณีพัสดุต่ำกว่า 3 ชิ้น คิดค่าบริการเข้ารับ 100 บาท)",
        },
    },
    DEFAULT: {
      maxSize: {
        width: 200,
        length: 200,
        height: 200,
      },
      maxWLH: 600,
      maxWeight: 50000,
    },
  SHF: {
    maxSize: {
      width: 150,
      length: 150,
      height: 150,
    },
    maxWLH: 280,
    banner: {
      code: '',
    },
    zoneName: {
      1: "ต้นทางและปลายทาง: กรุงเทพฯ/ปริมณฑล",
      2: "ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      3: "ต้นทาง: เหนือ, อีสาน, ใต้, กลาง - ปลายทาง: กรุงเทพฯ/ปริมณฑล",
      4: "ต้นทาง: เหนือ - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      5: "ต้นทาง: อีสาน - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      6: "ต้นทาง: ใต้ - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      7: "ต้นทาง: กลาง - ปลายทาง: เหนือ, อีสาน, ใต้, กลาง",
      8: "ต้นทาง - ปลายทาง: ภายในจังหวัด (เหนือ)",
      9: "ต้นทาง - ปลายทาง: ภายในจังหวัด (อีสาน)",
      10: "ต้นทาง - ปลายทาง: ภายในจังหวัด (ใต้)",
      11: "ต้นทาง - ปลายทาง: ภายในจังหวัด (กลาง)",
    },
  },
  EMSF: {
    maxSize: {
      width: 60,
      length: 60,
      height: 60,
    },
    maxWLH: 120,
    zoneName: {
      null: "ทั่วไป",
    },
  },
};
rules[_COURIERS_.DHL.key] = {
  banner: {
    code: `DF_${_COURIERS_.DHL.key+vm.$THEME.bannerPrefix}`,
  },
  maxSize: {
    width: 170,
    length: 170,
    height: 170,
  },
  maxWLH: 250,
  dimensionRatio: new Date() >= new Date("2024-01-01 00:00:00") ? 0 : 5000,
  calculateDimensionWeightAt: new Date() >= new Date("2024-01-01 00:00:00") ? 0 : 160,
  alertText: {
    text: [
      "การสร้างรายการ: จันทร์ ถึง วันอาทิตย์",
      "การเข้ารับ: วันจันทร์ - เสาร์",
      "กรณีพัสดุขนาดเกินทุกด้านรวมกันเกิน 200 ซม. หรือน้ำหนักเกิน 30 กิโลกรัม ทางขนส่งจะปฎิเสธการจัดส่งพัสดุ",
    ],
    // emphasize: "กรณีขนาดพัสดุทุกด้านรวมกันเกิน 160 ซม. จะคิดราคาน้ำหนักปริมาตร (Pick up เท่านั้น ไม่สามารถนำไป Drop เองที่สาขาได้)",
  },
  zoneName: {
    1: "ปลายทาง: กทม/ปริมณฑล",
    2: "ปลายทาง: กลาง/ตะวันออก",
    3: "ปลายทาง: เหนือ/อีสาน/ใต้",
  },
  // workingDays: [2, 3, 4, 5, 6],
  // workingHours: {
  //   1: "all",
  //   2: "all",
  //   // 2: {
  //   //   start: {hour: 11},
  //   // },
  //   3: "all",
  //   4: "all",
  //   5: "all",
  //   6: "all",
  //   // 6: {
  //   //   end: {hour: 11},
  //   // },
  // },
};
// if (new Date() < new Date("2022-07-01 00:00:00")) {
  // โปรโมชั่น DHL ก+ย+ส สูงสุดจาก 200cm เป็น 250 cm ถึง 30 มิ.ย. 65 (https://shippop.atlassian.net/browse/SP-1606)
//
// }
if (new Date() < new Date("2022-11-01 00:00:00")) {
  // คิดขนาดกล่องเท่านั้น dimension weight
  rules['SPXP'].useDimensionWeightOnly = true;
}

let courierRules = {
  imageCourier: {
    ARM: "ARM.png"
  },
  interCourierKey: [
    "CRDHL", // DHL e-commerce (Express)
    "CRARMPPX", // Aramex - PPX ส่งด่วน พัสดุ
    "CRARMEPX", // Aramex - EPX ส่งธรรมดา
    "CRARMPDX", // Aramex - PDX ส่งด่วน เอกสาร
    "CRTPEP", // Thai Post - ePacket ส่งธรรมดา
    "CRTPEWD", // Thai Post - EMS World (Document) ส่งด่วน เอกสาร
    "CRTPEWP", // Thai Post - EMS World (Package) ส่งด่วน พัสดุ
    "CRDHLPPS", // DHL - PPS ส่งธรรมดา ลงทะเบียน
    "CRTPEP2", // Thai Post - ePacket ส่งธรรมดา (2)
    "CRSHIP2LAOS", // Road To LAOS
    "CRSHIP2LAOS2", // CRSHIP2LAOS2
    "CRUPS07", // CRUPS07
    "CRUPS65", // CRUPS65
    "CRUPS08" // CRUPS08
  ],
  shippopCourierKeys: [
    "FLE",
    "FLEB",
    "FLEF",
    "FLEWP",
    "CJLX",
    "NJV",
    "TRUE",
    "SCG",
    "SCGC",
    "SCGF",
    "JNT",
    "ECP",
    "BEST",
    "TP2",
    "ECP",
    "THP",
    "EMST",
    "EMSX",
    "EMSW",
    "BEE",
    "TPSD",
    "MSE",
    "MSEC",
    "MSEF",
    "SPE",
    "SPEC",
    "SPXP",
    "KRYS",
    "EMSXP",
    "KRYQ",
    "ORNG",
    _COURIERS_.DHL.key,
    "XPSO",
    "XPSD",
    "SHF",
    "EMSF"
  ],
  // courier check remote area
  extraCouriers: [
    "FLE",
    "FLEB",
    "FLEF",
    "FLEWP",
    "SCG",
    "CJLX",
    "NJV",
    "SCGC",
    "SCGF",
    "JNT",
    "BEST",
    "MSE",
    "MSEC",
    "MSEF",
    "SPE",
    "SPEC",
    "SPXP",
    "KRYS",
    "KRYQ",
    "ORNG",
    "ECP",
    "THP",
    "EMST",
    "EMSXP",
    "SHF",
    "EMSF"
  ],
  dimensionCouriers: [
    "SCG",
    "TRUE",
    "FLE",
    "FLEF",
    "FLEB",
    "FLEWP",
    "SCGC",
    "SCGF",
    "NJV",
    "BEE",
    "TPSD",
    "MSE",
    "MSEC",
    "MSEF",
    "SPE",
    "SPEC",
    "CJLX",
    "KRYS",
    "KRYQ",
    "ORNG",
    "SPXP",
    _COURIERS_.DHL.key,
    "XPSO",
    "XPSD",
    "SHF"
  ],
  enableFlashBooking: ['FLE', 'FLEWP', 'FLEF', 'FLEB'],
  enableEmstBooking: ['EMST', 'EMSX', 'EMSXP', 'EMSF'],
  lockWeightCouriers: ["KRYS"],
  lockDimensionCouriers: ["SCG", "SCGC", "SCGF", "KRYS"],
  changeDimensionBySize: [ "SCGC", "SCGF", "KRYS" ],
  courierServiceArea: [
    "SCG",
    "SCGC",
    "SCGF",
    "FLE",
    "FLEB",
    "FLEF",
    "FLEWP",
    "NJV",
    "BEST",
    "KRYS",
    "KRYQ",
    "ORNG",
    _COURIERS_.DHL.key,
    "SHF"
  ],
  extraHandlingCharge: [
    _COURIERS_.DHL.key
  ],
  workingDayOfCourier: [_COURIERS_.DHL.key],
  // 1="Monday"
  // 2="Tuesday"
  // 3="Wednesday"
  // 4="Thursday"
  // 5="Friday"
  // 6="Saturday"
  // 0="Sunday"
  alertBeforeCreateOrderCouriers: [
    "BEE",
    "TRUE",
    "TPSD",
    "MSE",
    "MSEC",
    "MSEF",
    "SPE",
    "SPEC",
    _COURIERS_.DHL.key,
    "SCG",
    "SCGC",
    "SCGF",
    "XPSO",
    "XPSD",
    "FLEDS"
  ],
  ...rules,

  getZoneName: function(courier, rateType = null) {
    console.log('get zone name', courier)
    if (['JNTP', 'JNTD'].includes(courier.key) && rateType) {
      return rules['JNT'].zoneName[rateType]
    }

    if (!rules[courier.key]) {
      return "ทั่วไป";
    }

    let zoneName = rules[courier.key].zoneName;

    if (!zoneName) {
      return "ทั่วไป";
    }
    if (
      ["BEST"].includes(courier.key)
    ) {
      if (new Date(courier.effective_date >= new Date('2023-12-15 00:00:00'))) {
        zoneName = {
          1: 'ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: กรุงเทพฯ/ปริมณฑล',
          2: 'ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: ภาคกลาง/เหนือ/อีสาน',
          3: 'ต้นทาง: กรุงเทพฯ/ปริมณฑล - ปลายทาง: ภาคใต้',
          4: 'ต้นทาง: ภาคกลาง/เหนือ/อีสาน - ปลายทาง: กรุงเทพฯ/ปริมณฑล',
          5: 'ต้นทาง: ภาคกลาง/เหนือ/อีสาน - ปลายทาง: ภาคใต้',
          6: 'ต้นทาง: ภาคกลาง/เหนือ/อีสาน - ปลายทาง: ภาคกลาง/เหนือ/อีสาน',
          7: 'ต้นทาง: ภาคใต้ - ปลายทาง: กรุงเทพฯ/ปริมณฑล',
          8: 'ต้นทาง: ภาคใต้ - ปลายทาง: ภาคกลาง/เหนือ/อีสาน',
          9: 'ต้นทาง: ภาคใต้ - ปลายทาง: ภาคใต้'
        };
      } else if (new Date(courier.effective_date) < new Date("2022-01-13 00:00:00")) {
        zoneName = {
          1: "ส่งภายใน: กรุงเทพฯ/ปริมณฑล",
          2: "ต้นทาง:  กรุงเทพฯ/ปริมณฑล - ปลายทาง: ต่างจังหวัด",
          3: "ส่งภายในภาคเดียวกัน",
          4: "ต้นทาง: ต่างจังหวัด - ปลายทาง: กรุงเทพฯ/ปริมณฑล",
          5: "ต้นทาง: ต่างภาค - ปลายทาง: ต่างภาค",
          6: "ภายในจังหวัดเดียวกัน",
          7: "ภายในจังหวัดเดียวกัน (ภาคกลาง)",
          8: "ต่างภาค",
        };
      }
    } else if (
      ["SPXP"].includes(courier.key) &&
      (
        new Date(courier.effective_date) < new Date("2022-11-01 00:00:00") ||
        new Date(courier.shipment_created_at) < new Date("2022-11-01 00:00:00")
      )
    ) {
      zoneName = {
        1: "ปลายทาง: กรุงเทพ/ปริมณฑล",
        2: "ปลายทาง: ต่างจังหวัด",
      };
    } else if (
      ["MSE", 'MSEC'].includes(courier.key) &&
      (
        new Date(courier.effective_date) < new Date("2023-01-01 00:00:00") ||
        new Date(courier.shipment_created_at) < new Date("2023-01-01 00:00:00")
      )
    ) {
      zoneName = {
        1: "ต้นทาง: กรุงเทพฯ - ปริมณฑล ปลายทาง: กรุงเทพฯ",
        2: "ต้นทาง:	กรุงเทพฯ - ปริมณฑล ปลายทาง: ปริมณฑล (นนทบุรี, ปทุมธานี, สมุทรปราการ นครปฐม และสมุทรสาคร)",
        3: "ต้นทาง:	กรุงเทพฯ - ปริมณฑล ปลายทาง:	ต่างจังหวัด (ชลบุรี, ราชบุรี, เพชรบุรี, หัวหิน, สมุทรสงคราม, นครราชสีมา)",
        4: "ต้นทาง:	ชลบุรี ปลายทาง:	ภายในจังหวัด",
        5: "ต้นทาง:	ชลบุรี ปลายทาง:	กรุงเทพฯ-ปริมณฑล",
        6: "ต้นทาง: เพชรบุรี, หัวหิน, สมุทรสงคราม, ราชบุรี ปลายทาง:	ภายในจังหวัด",
        7: "ต้นทาง: เพชรบุรี, หัวหิน, สมุทรสงคราม, ราชบุรี ปลายทาง:	จังหวัดใกล้เคียง",
        8: "ต้นทาง:	เพชรบุรี, หัวหิน, สมุทรสงคราม, ราชบุรี ปลายทาง:	กรุงเทพฯ-ปริมณฑล",
        9: "ต้นทาง:	ขอนแก่น, นครศรีธรรมราช ปลายทาง:	ภายในจังหวัด",
        10: "ต้นทาง: นครราชสีมา ปลายทาง: ภายในจังหวัด",
        11: "ต้นทาง: นครราชสีมา ปลายทาง: กรุงเทพฯ - ปริมณฑล",
      };
    } else if (
      ["KRYS", 'KRYQ'].includes(courier.key) &&
      new Date(courier.effective_date) >= new Date("2023-09-05 00:00:00")
    ) {
      console.log('new 3 rules ', courier.key)
      zoneName = {
        1: 'ภายในจังหวัดเดียวกัน',
        2: 'ไม่เกิน 1200 กม.',
        3: 'มากกว่า 1200 กม.'
      }
    }

    return zoneName[rateType] ? zoneName[rateType] : "ทั่วไป";
  },
};

if (new Date() >= new Date("2023-09-05 00:00:00")) {
  rules['KRYS'].dimensionRatio = 3000;
  rules['KRYQ'].dimensionRatio = 3000;

  rules['KRYS'].maxSize = {
    width: 200,
    length: 200,
    height: 200,
  };
  rules['KRYS'].maxWLH = 280;

  if (courierRules['extraCouriers'].indexOf('KRYS') !== -1) {
    courierRules['extraCouriers'].splice(courierRules['extraCouriers'].indexOf('KRYS'), 1);
  }

  if (courierRules['extraCouriers'].indexOf('KRYQ') !== -1) {
    courierRules['extraCouriers'].splice(courierRules['extraCouriers'].indexOf('KRYQ'), 1);
  }

  if (courierRules['lockWeightCouriers'].indexOf('KRYS') !== -1) {
    courierRules['lockWeightCouriers'].splice(courierRules['lockWeightCouriers'].indexOf('KRYS'), 1);
  }

  if (courierRules['lockDimensionCouriers'].indexOf('KRYS') !== -1) {
    courierRules['lockDimensionCouriers'].splice(courierRules['lockDimensionCouriers'].indexOf('KRYS'), 1);
  }

  if (courierRules['changeDimensionBySize'].indexOf('KRYS') !== -1) {
    courierRules['changeDimensionBySize'].splice(courierRules['changeDimensionBySize'].indexOf('KRYS'), 1);
  }

  if (courierRules.dimensionCouriers.indexOf('KRYS') !== -1) {
    courierRules.dimensionCouriers.splice(courierRules.dimensionCouriers.indexOf('KRYS'), 1);
  }

  if (courierRules.dimensionCouriers.indexOf('KRYQ') !== -1) {
    courierRules.dimensionCouriers.splice(courierRules.dimensionCouriers.indexOf('KRYQ'), 1);
  }

}

const senderStorage = JSON.parse(localStorage.getItem('sender_storage')) || {}
const shopId = Object.keys(senderStorage)[0] || ''

if (shopId === 'PS-002995') {
  courierRules.FLEB.minWeight = 1
}

export default courierRules;
